import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const creditCardRoutes: RouteObject[] = [
  {
    path: '/credit-card',
    element: lazyElement(() => import('./Search')),
    handle: {
      documentTitle: 'Credit Cards',
      crumb: () => ({ label: 'Credit Cards', to: '/credit-card' }),
    },
  },
  {
    path: '/credit-card/charges',
    element: lazyElement(() => import('./Charges')),
    handle: {
      documentTitle: 'Credit Card Charges',
      crumb: () => ({ label: 'Charges', to: '/credit-card/charges' }),
    },
  },
  {
    path: '/credit-card/:hash',
    element: lazyElement(() => import('./View')),
    handle: {
      documentTitle: 'Credit Card',
      crumb: () => ({ label: 'Card' }),
    },
  },
];

export default creditCardRoutes;
